import Nullstack from 'nullstack';
export default function IconFileSettings({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-file-settings",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "14",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M12 10.5v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M15.031 12.25l-1.299 .75"
  }), "   ", Nullstack.element("path", {
    d: "M10.268 15l-1.3 .75"
  }), "   ", Nullstack.element("path", {
    d: "M15 15.803l-1.285 -.773"
  }), "   ", Nullstack.element("path", {
    d: "M10.285 12.97l-1.285 -.773"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), " ");
}